'use client';

interface GoogleLoginButtonProps {
  onError?: (error: string) => void;
  redirectTo?: string;
}

export default function GoogleLoginButton({ redirectTo }: GoogleLoginButtonProps) {
  const safeRedirect = redirectTo && redirectTo.startsWith('/') ? redirectTo : '/chat';
  const href = `/api/auth/google/start?redirect=${encodeURIComponent(safeRedirect)}`;

  return (
    <a
      href={href}
      className="w-full h-[52px] flex items-center justify-center gap-s2 rounded-lg border border-white/20 bg-white/5 hover:bg-white/10 hover:border-white/30 transition-colors duration-150"
    >
      <svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.0461 12.2099C21.0461 11.5553 20.9874 10.9259 20.8783 10.3217H12.1846V13.8966H17.1524C16.9342 15.0462 16.2797 16.0197 15.2979 16.6742V18.9987H18.2937C20.0391 17.3875 21.0461 15.0211 21.0461 12.2099Z" fill="#4285F4"/>
        <path d="M12.1844 21.2307C14.6767 21.2307 16.7662 20.4084 18.2935 18.9986L15.2977 16.6741C14.4753 17.2279 13.4264 17.5636 12.1844 17.5636C9.78441 17.5636 7.74525 15.944 7.01518 13.7622H3.94385V16.1454C5.46273 19.158 8.57602 21.2307 12.1844 21.2307Z" fill="#34A853"/>
        <path d="M7.01516 13.7539C6.83054 13.2 6.72145 12.6126 6.72145 12C6.72145 11.3874 6.83054 10.8 7.01516 10.2462V7.86295H3.94382C3.31445 9.10491 2.95361 10.5063 2.95361 12C2.95361 13.4937 3.31445 14.8951 3.94382 16.1371L6.33544 14.2741L7.01516 13.7539Z" fill="#FBBC05"/>
        <path d="M12.1844 6.44475C13.5439 6.44475 14.7522 6.91469 15.7173 7.82098L18.3606 5.17762C16.7578 3.68391 14.6767 2.76923 12.1844 2.76923C8.57602 2.76923 5.46273 4.84196 3.94385 7.86294L7.01518 10.2462C7.74525 8.06434 9.78441 6.44475 12.1844 6.44475Z" fill="#EA4335"/>
      </svg>
      <span className="text-[rgb(var(--text-primary))] text-sm font-medium">Continue with Google</span>
    </a>
  );
}
